<template>
  <footer>
    <div
      class="footer"
      style="
        padding-top: 20px;
        position: relative;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        width: 100%;
        background-color: #000;
        color: white;
      "
    >
      <div
        class="footer-top"
        style="display: flex; width: 100%; justify-content: space-around"
      >
        <!-- <img class="company" src="../assets/vi/index/company.png'" alt="版号公司徽标" style=" width: 103px;
    height: 21px;" />
        <img class="level" src="../assets/vi/index/logo18.png" alt="18+logo" style="width: 80px;
    height: 31px;" /> -->
        <!-- <img
          class="company"
          :src="require('@/assets/vi/index/company.png')"
          alt="版号公司徽标"
          style="width: 103px; height: 21px"
        /> -->
        <img
          class="company"
          :src="require('@/assets/vi/index/logo2.png')"
          alt="版号公司徽标"
          style="width: 203px; height: 41px"
        />
        <img
          class="level"
          :src="require('@/assets/vi/index/logo18.png')"
          alt="18+logo"
          style="width: 160px; height: 62px"
        />
      </div>
      <div
        class="footer-center"
        style="margin: 3px 0 3px; font-size: 12px; color: #ffe3ca"
      >
        <a
          href="https://www.lucdiathanhoa.com/terms"
          target="_blank"
          style="
            font-size: inherit;
            color: inherit;
            margin: 0 3px;
            text-decoration: underline;
          "
          >Điều Khoản</a
        >
        <a
          href="https://www.lucdiathanhoa.com/VhPrivacyAgreement.html"
          target="_blank"
          style="
            font-size: inherit;
            color: inherit;
            margin: 0 3px;
            text-decoration: underline;
          "
          >Bảo Mật</a
        >
      </div>
      <div
        class="footer-bottom"
        style="margin-bottom: 19px; text-align: center"
      >
        <p style="font-size: 12px; color: #ffe3ca; line-height: 14px">
          Công ty TNHH Mobile Intelligence Saigon
        </p>
        <p style="font-size: 12px; color: #ffe3ca; line-height: 14px">
          23 Lê Thị Riêng, phường Bến Thành, quận 1, TP.HCM
        </p>
        <p style="font-size: 12px; color: #ffe3ca; line-height: 14px">
          Quyết định phê duyệt nội dung kịch bản trò chơi điện tử G1
        </p>
        <p style="font-size: 12px; color: #ffe3ca; line-height: 12px">
          trên mạng số: 1784/QĐ-BTTTT ngày 18/10/2024
        </p>
        <p style="font-size: 12px; color: #ffe3ca; line-height: 12px">
          Chịu trách nhiệm nội dung: Ông Trần Quốc Bảo
        </p>
        <p style="font-size: 12px; color: #ffe3ca; line-height: 14px">
          Email CSKH:
          <a
            href="mailto:htkh.cskh@gmail.com"
            style="color: #197ed5; font-size: 12px; line-height: 14px"
            >htkh.cskh@gmail.com</a
          >
        </p>
      </div>
    </div>
  </footer>
</template>

<style lang="css">
.footer {
  padding-top: 20px;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.footer .footer-top {
  display: flex;
  width: 100%;
  justify-content: space-around;
}

.footer .footer-top .company {
  width: 2.07rem;
  height: 0.43rem;
}
.footer .footer-top .level {
  width: 1.59rem;
  height: 0.63rem;
}

.footer .footer-center {
  margin: 0.6rem 0 0.5rem;
  font-size: 0.22rem;
  color: #ffe3ca;
}

.footer .footer-center a {
  font-size: inherit;
  color: inherit;
  margin: 0 0.7rem;
  text-decoration: underline;
}

.footer .footer-bottom {
  margin-bottom: 0.38rem;
  text-align: center;
}

.footer .footer-bottom p,
a {
  font-size: 0.2rem;
  color: #ffe3ca;
  line-height: 0.4rem;
}
.footer .footer-bottom a {
  color: #197ed5;
}
</style>

<script>
export default {
  props: {},
  computed: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
